import { NgModule } from "@angular/core";
import { NavigationPositionBarComponent } from "./navigation-position-bar/navigation-position-bar.component";
import { FormNavigationControlsComponent } from "./form-navigation-controls/form-navigation-controls.component";
import { SharedModule } from "../../shared/shared.module";
import { MobilePositionBar } from "./navigation-position-bar/mobile-position-bar/mobile-position-bar.component";

@NgModule({
    declarations: [
    ],
    imports: [
        SharedModule,
        NavigationPositionBarComponent,
        FormNavigationControlsComponent,
        MobilePositionBar
    ],
    exports: [
        NavigationPositionBarComponent,
        FormNavigationControlsComponent
    ]
})
export class NavigationModule{}